import { type FC } from "react";

import { DraftingSectionStatusEnum } from "@app_schema";

import { Badge, type BadgeColor, type BadgeVariant } from "./badge";

// Only writing and drafted have one: a waiting section says so beside its name (SectionRow), and his own say
// they're his in their line.
const PILL: Partial<
  Record<
    DraftingSectionStatusEnum,
    { label: string; color: BadgeColor; variant?: BadgeVariant }
  >
> = {
  [DraftingSectionStatusEnum.Writing]: { label: "Writing…", color: "sky" },
  [DraftingSectionStatusEnum.Drafted]: { label: "Drafted", color: "emerald" },
};

// A Drafting section's status at the right of its line.
export const SectionStatusPill: FC<{ status: DraftingSectionStatusEnum }> = ({
  status,
}) => {
  const pill = PILL[status];
  if (!pill) return null;

  return (
    <Badge pill color={pill.color} variant={pill.variant}>
      {pill.label}
    </Badge>
  );
};
